// extracted by mini-css-extract-plugin
export default {"container":"Np-z","brandName":"Op-z","productName":"Pp-z","productNamePdpEnhancements":"Qp-z","breakLongProductName":"Rp-z"};